import { NextPageContext } from 'next'

/** Определяет по юзер-агенту, мобила сейчас или десктоп */
export const isTouch = async (ctx: NextPageContext): Promise<boolean> => {
  const headers = ctx && ctx.req && ctx.req.headers

  if (headers) {
    return Boolean(headers.viewport === 'mobile')
  }

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Mobi/i.test(
      navigator.userAgent
    )

  return Boolean(isMobile)
}
